import React, { useCallback } from 'react';

/**
 * Teclado Numérico para busca por matrícula/CPF
 * Layout com cantos retos e largura total
 */
const NumericKeyboard = ({ onKeyPress, onDelete, onClear, onConfirm, confirmLabel = "CONTINUAR", confirmDisabled = false }) => {
    const handleKey = useCallback((key) => {
        onKeyPress?.(key);
    }, [onKeyPress]);

    const btnStyle = {
        width: "72px",
        height: "72px",
        fontSize: "28px",
        fontWeight: "700",
        borderRadius: "50%",
        border: "1.5px solid #482712",
        backgroundColor: "#fff",
        color: "#482712",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(72, 39, 18, 0.06)",
        padding: "0",
        transition: "all 0.2s ease"
    };

    return (
        <div className="w-100 d-flex flex-column align-items-center">
            {/* Grid 3x4 */}
            <div className="d-flex flex-column" style={{ gap: "12px" }}>
                {/* Linha 1 */}
                <div className="d-flex justify-content-center" style={{ gap: "16px" }}>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("1")}>1</button>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("2")}>2</button>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("3")}>3</button>
                </div>
                {/* Linha 2 */}
                <div className="d-flex justify-content-center" style={{ gap: "16px" }}>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("4")}>4</button>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("5")}>5</button>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("6")}>6</button>
                </div>
                {/* Linha 3 */}
                <div className="d-flex justify-content-center" style={{ gap: "16px" }}>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("7")}>7</button>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("8")}>8</button>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("9")}>9</button>
                </div>
                {/* Linha 4: X | 0 | ⌫ */}
                <div className="d-flex justify-content-center" style={{ gap: "16px" }}>
                    <button
                        className="btn"
                        style={{ ...btnStyle, border: "1.5px solid #dc3545", color: "#dc3545", fontSize: "24px" }}
                        onClick={onClear}
                    >
                        ✕
                    </button>
                    <button className="btn" style={btnStyle} onClick={() => handleKey("0")}>0</button>
                    <button
                        className="btn"
                        style={{ ...btnStyle, border: "1.5px solid #6b7280", color: "#6b7280" }}
                        onClick={onDelete}
                    >
                        <i className="mdi mdi-backspace font-size-24" style={{ marginLeft: "-2px" }}></i>
                    </button>
                </div>
            </div>

            {/* Botão CONTINUAR */}
            {onConfirm && (
                <button
                    className="btn w-100 mt-4 fw-bold text-uppercase"
                    style={{
                        height: "50px",
                        fontSize: "15px",
                        letterSpacing: "1.5px",
                        borderRadius: "100px",
                        backgroundColor: confirmDisabled ? "#d6e4f0" : "#e2661c",
                        color: "#fff",
                        border: "none",
                        boxShadow: confirmDisabled ? "none" : "0 4px 12px rgba(226, 102, 28, 0.25)",
                    }}
                    onClick={onConfirm}
                    disabled={confirmDisabled}
                >
                    {confirmLabel}
                </button>
            )}
        </div>
    );
};

export default NumericKeyboard;
